import React from 'react';
import Grid from '@mui/material/Grid';
import { useNavigate } from 'react-router-dom';

import { InfoField, ChipBox } from '@occc-app/design-system';
import { EarningMechanismTotalEligiblePurchaseOverTimeFragment } from '@occc/graphql';

import { formatProductCounting } from '../utils';

interface ITotalEligiblePurchaseOverTimeProps {
  earningMechanism: EarningMechanismTotalEligiblePurchaseOverTimeFragment;
}

export const TotalEligiblePurchaseOverTime: React.FC<ITotalEligiblePurchaseOverTimeProps> = ({
  earningMechanism,
}) => {
  const navigate = useNavigate();
  const onChipClick = React.useCallback(
    (pgId: string) => {
      navigate(`/product-groups/${pgId}`);
    },
    [navigate],
  );

  return (
    <Grid container spacing={2}>
      <Grid item sm={6}>
        <InfoField
          disableTypography
          label='Included Product Groups'
          value={
            <ChipBox items={earningMechanism?.eligibleProductGroups} onClick={onChipClick} mt={0} />
          }
        />
      </Grid>
      <Grid item sm={3}>
        <InfoField label='Count Products By' value={formatProductCounting(earningMechanism)} />
      </Grid>
      <Grid item sm={3}>
        <InfoField label='Accumulation Threshold' value={earningMechanism?.accumulationThreshold} />
      </Grid>
    </Grid>
  );
};
